'use client';

import { useEffect, useState } from 'react';
import { throttle } from 'utils/common';

// 100vh 가 모바일에서는 url bar, tool bar height 까지 포함 시킨다.
// 따라서 전체 화면에 적용하고 싶은 요소가 있으면 window.innerHeight 를 사용하는 것이 안전하다.
// https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
export const useViewPort = () => {
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    setSize({ width: window.innerWidth, height: window.innerHeight });
  }, []);

  useEffect(() => {
    const resizeEditor = throttle(() => {
      setSize({ width: window.innerWidth, height: window.innerHeight });
    }, 300);

    window.addEventListener('resize', resizeEditor);

    return () => {
      window.removeEventListener('resize', resizeEditor);
    };
  }, []);

  return size;
};
